<sk-modal-content [title]="'label.workflows.StatesDiagram' | translate"
                  [isHideCloseBtn]="true"
                  (closed)="closeWithoutResult()">

  <ng-container id="sk-modal-body">
    <div [style.height.px]="diagramHeight" class="canvas-container">
      <div id="mycanvas" class="absolute-box"></div>
    </div>
  </ng-container>

  <ng-container id="sk-modal-footer-buttons">
    @if (canSave) {
      <sk-button
        [color]="'primary'"
        [label]="'label.SaveView' | translate"
        data-test="modal-footer-confirm-button"
        (click)="savePosition()">
        <ng-template buttonPrefix>
          <i class="fas fa-check"></i>
        </ng-template>
      </sk-button>
    }
    <sk-button
      [label]="'label.Close' | translate"
      data-test="modal-footer-close-button"
      [appearance]="'link'"
      [color]="'primary'"
      (click)="dialogRef.close()">
      <ng-template buttonPrefix>
        <i class="far fa-times"></i>
      </ng-template>
    </sk-button>
  </ng-container>
</sk-modal-content>
